import axios from 'axios';

import config from '../../utils/config';

import * as AuthActions from '../../actions/auth';
import * as AuthCreators from '../../creators/auth';
import * as Interceptors from '../../interceptors';
import store from '../../store/store';

import { URL_SUBSCRIPTION } from '../../modules/PaymentSubscription/utils/urlUtils/subscription';

const URLRefresh = config().refresh;
const dispatchStore = store.dispatch;

export default function interceptorResponse() {

  return axios.interceptors.response.use(response => response, (error) => {

    if (error.response.status === 401 && error.response.config.url !== URLRefresh) {

      if (!error.response.config.url.includes(URL_SUBSCRIPTION)) {
        dispatchStore(AuthActions.fetchAuthLoading());
      }

      return refreshToken(Interceptors.getRefreshToken()).then(response => {
        Interceptors.setToken(response.data.access);
        axios.defaults.headers.common['Authorization'] = `Bearer ${Interceptors.getToken()}`;

        dispatchStore(AuthActions.fetchAuthSuccess(response.data.access));

        return repeatedRequest(
          getRepeatedParams(error.response.config), error.response.headers, Interceptors.getToken()
        );
      }).catch((nextError) => {

        if (!nextError.response.config.url.includes(URLRefresh)) {

          return Promise.reject(nextError);
        }

        dispatchStore(AuthCreators.onLogout());
        return Promise.reject(nextError);
      });
    }
    return Promise.reject(error);
  });
}

function repeatedRequest(errorConfig, errorHeaders, newToken) {
  return axios({
    ...errorConfig,
    headers: {
      ...errorHeaders,
      Authorization: `Bearer ${newToken}`
    },
  });
}

function getRepeatedParams(errorConfig) {
  if (errorConfig.method !== 'get') {
    errorConfig.data = JSON.parse(errorConfig.data);
  }
  return errorConfig;
}

const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
};

function refreshToken(receivedToken) {
  const params = new URLSearchParams();
  params.append('refresh', receivedToken);

  return axios.post(`${URLRefresh}`, params, axiosConfig);
}
